import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: string;
  title: string;
  author: string;
  category: string;
  rating: number;
  views: string;
  chapters: number;
  status: string;
  coverImage: string;
  tags?: string[];
  featured?: boolean;
}

export default function ComicCard({
  id,
  title,
  rating,
  chapters,
  status,
  coverImage,
  tags,
}: ComicCardProps) {
  return (
    <Link
      to={`/comic/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-200 mb-3">
        <img
          src={coverImage}
          alt={title}
          title={`${title} - 韩漫免费看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute top-2 left-2 flex flex-wrap gap-1">
          {tags?.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 text-xs rounded-md bg-background-50/90 text-foreground-800 backdrop-blur-sm"
            >
              {tag}
            </span>
          ))}
        </div>
        <div className="absolute bottom-3 left-3 right-3">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs text-accent-400 font-semibold bg-accent-500/20 px-1.5 py-0.5 rounded">
              ★ {rating}
            </span>
            <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${
              status === '连载中' ? 'bg-primary-500/80 text-background-50' : 'bg-foreground-500/60 text-background-50'
            }`}>
              {status}
            </span>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-950 font-heading mb-1 truncate group-hover:text-primary-600 transition-colors">
        {title}
      </h3>
      <p className="text-xs text-foreground-500">
        已更新至第{chapters}话
      </p>
    </Link>
  );
}